import { PathSegment } from './path-segment';
import { OptionGroup } from './option-group';
import { Journey } from '@/models/journey';

export class AdditionalOptionsPathSegment extends PathSegment
{
    public readonly optionGroups: Array<OptionGroup> = [];


    constructor(title: string,
        alias: string,
        price: number,
        showPrice: boolean,
        isCostExternal: boolean,
        optionGroups: Array<OptionGroup>,
        dataObject?: Journey,
        children?: Array<PathSegment>)
    {
        super('AdditionalOptionsPathSegment', title, alias, price, showPrice, isCostExternal, children, dataObject);
        this.optionGroups = optionGroups;
    }
}
